import React from "react";
import { useDispatch } from "react-redux";
import { novoDB, triggerLoadNovoDB } from "../dbs/dbsSlice";
import { calculaResultadosLivrudo, carregaLivrudoDB } from "./LivrudoSlice";
import { Grid, Stack, Table, Typography } from "@mui/joy";
import { useSelector } from "react-redux";

function LivrudoResultadosPage() {

    var dispatch = useDispatch()
    var dbs = useSelector((state) => state.dbs.dbs)
    var resultados = useSelector(state => state.livrudo.resultados)
    var loaded = false


    if (Object.keys(dbs).includes("livrudo")) {
        loaded = dbs.livrudo.loaded
    }

    React.useEffect(() => {
        dispatch(triggerLoadNovoDB(
            novoDB("livrudo", 10, "db", (p) => {

                var db = p.payload
                var versao = p.versao

                dispatch(carregaLivrudoDB(db != null ? db : {}))
                dispatch(calculaResultadosLivrudo())
            })
        ))
    }, []);

    if(!loaded) return "Loading..."

    console.log(resultados)

    function retornaCompras() {
        if(resultados != null) {
            var compras = resultados.compras
            const chaves = Object.keys(compras).sort((a, b) => new Date(b) - new Date(a));

            return chaves.map(c => {

                const data = {
                    data: c,
                    total : compras[c].valor.total,
                    qtde : compras[c].qtde.total
                }

                return <tr>
                    <td>{data.data}</td>
                    <td>R$ {data.total.toFixed(2)}</td>
                    <td>{data.qtde}</td>
                </tr>
                
            })

        }
    }

    function retornaVendas() {
        if(resultados != null) {
            var vendas = resultados.vendas
            const chaves = Object.keys(vendas).sort((a, b) => new Date(b) - new Date(a));

            return chaves.map(c => {

                var qtde = vendas[c].qtde.total

                if(c === "2025-03") {
                    qtde = qtde - 2
                }

                if( c === "2025-05") {
                    qtde = qtde - 5
                }

                const data = {
                    data: c,
                    valorVenda : vendas[c].valorVenda.total,
                    valorCompra: vendas[c].valorCompra.total,
                    liquido: vendas[c].liquido.total,
                    qtde : qtde,
                    tarifa: vendas[c].tarifa.total,
                    lucro : vendas[c].lucro.total,
                    tm : vendas[c].valorVenda.total / qtde,
                    lm : vendas[c].lucro.total / qtde,
                    ml : vendas[c].lucro.total / vendas[c].valorVenda.total,
                    roi: (vendas[c].lucro.total) / vendas[c].valorCompra.total
                }

                    {/* <th>Data</th>
                        <th>Vendido</th>
                        <th>Comprado</th>
                        <th>Custo</th>
                        <th>Liquido</th>
                        <th>Lucro</th>
                        <th>Qtde</th>
                        <th>LM</th>
                        <th>TM</th>
                        <th>ROI</th> */}
                return <tr>
                    <td>{data.data}</td>
                    <td>R$ {data.valorVenda.toFixed(2)}</td>
                    <td>R$ {data.tarifa.toFixed(2)}</td>
                    <td>R$ {data.liquido.toFixed(2)}</td>
                    <td>R$ {data.valorCompra.toFixed(2)}</td>
                    <td>R$ {data.lucro.toFixed(2)}</td>
                    <td>R$ {data.tm.toFixed(2)}</td>
                    <td>R$ {data.lm.toFixed(2)}</td>
                    <td>{(data.ml*100).toFixed(1)}%</td>
                    <td>{(data.roi*100).toFixed(1)}%</td>
                    <td>R$ {((data.lucro)/((data.qtde > 0 ? data.qtde : 1)/2)).toFixed(2)}</td>
                    <td>{((data.qtde > 0 ? data.qtde : 1)*35/30).toFixed(0)}</td>
                    <td>{data.qtde}</td>
                </tr>
                
            })

        }

    }

    return <Grid container sx={{p: 1}} spacing={3}>
        <Grid xs={12}>
            <Stack spacing={1}>
                <Typography component={"h1"}>
                    Compras
                </Typography>
                <Table size="small" aria-label="striped table" stripe={"odd"}>
                    <thead>
                        <tr>
                        <th>Data</th>
                        <th>Total</th>
                        <th>Qtde</th>
                        </tr>
                    </thead>
                    <tbody>
                        {retornaCompras()}
                    </tbody>
                </Table>
            </Stack>
        </Grid>
        <Grid xs={12}>
            <Stack spacing={1}>
                <Typography component={"h1"}>
                    Vendas
                </Typography>
                <Table size="small" aria-label="striped table" stripe={"odd"}>
                    <thead>
                        <tr>
                        <th>Data</th>
                        <th>Faturado</th>
                        <th>Custo Venda</th>
                        <th>Liquido</th>
                        <th>Custo Compra</th>
                        <th>Lucro</th>
                        <th>TM</th>
                        <th>LM</th>
                        <th>ML</th>
                        <th>ROI</th>
                        <th>L/Hrt</th>
                        <th>Mt/Dm</th>
                        <th>Qtde</th>
                        </tr>
                    </thead>
                    <tbody>
                        {retornaVendas()}
                    </tbody>
                </Table>
            </Stack>
        </Grid>
    </Grid>
}

export default LivrudoResultadosPage